import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__/index.ts';

const ADD_TARGETS_TO_CUSTOM_COLLECTIONS = gql(`
  mutation AddTargetsToCustomCollections(
    $input: AddTargetsToCustomCollectionsInput!
  ) {
    addTargetsToCustomCollections(input: $input) {
      ...CustomCollectionFragment
    }
  }
`);

export type CustomCollectionRef = { id: string; streamDeckId: string };

export const useAddTargetsToCustomCollections = (streamId: string) => {
  const toast = useToast();

  const [mutate, result] = useMutation(ADD_TARGETS_TO_CUSTOM_COLLECTIONS, {
    onCompleted: ({ addTargetsToCustomCollections }) => {
      const count = addTargetsToCustomCollections.length;
      toast.success({
        title: `Targets added to ${count} ${count === 1 ? 'list' : 'lists'}`,
      });
    },
    onError: (e) => {
      toast.error({
        title: 'Failed to add targets to lists',
        subTitle: e.message,
      });
    },
    update: (cache, { data }) => {
      for (const collection of data?.addTargetsToCustomCollections ?? []) {
        cache.evict({
          fieldName: 'customCollectionPosts',
          args: { collectionId: collection.id },
        });
      }
      cache.gc();
    },
  });

  const addTargetsToCustomCollections = (
    targets: string[],
    collections: CustomCollectionRef[],
  ) =>
    mutate({
      variables: { input: { streamId, targets, collections } },
    });

  return [addTargetsToCustomCollections, result] as const;
};
